import type { OrganizationStatus } from "@vital/shared";

/** Mirror of server D6/D7 write policy for UI affordances only — server remains authoritative. */
export function organizationAllowsAdminWrites(
  status: OrganizationStatus | null | undefined,
): boolean {
  return status === "active" || status == null;
}

export const ORGANIZATION_STATUS_LABELS: Record<OrganizationStatus, string> = {
  draft: "پیش‌نویس",
  active: "فعال",
  suspended: "معلق",
  archived: "بایگانی‌شده",
};
